export default __webpack_public_path__ + "static/0294-0b79046fc4370a312807c8633f49cb2e.png";